/* eslint-disable */
<template>
  <b-modal
    id="trigger-cvs-talentpool"
    centered
    hide-footer
    hide-header
    :visible="showModal"
    no-close-on-backdrop
    @hidden="handleClose"
  >
    <main>
      <header>
        <div
          class="d-flex align-items-center justify-content-between px-4 py-3"
        >
          <div class="b-modal-header">Trigger CVS</div>
          <div class="rotate-on-hover" @click="handleClose">
            <img
              src="../../assets/panelist/blue_cross.svg"
              alt=""
              class="pointer rotate-on-hover"
            />
          </div>
        </div>
      </header>
      <hr class="m-0" />

      <body>
        <!-- Confirmation view: selected candidates + skills + trigger -->
        <section v-if="!successDetails" class="py-3 px-4">
          <section class="reassign-main-container p-3">
            <!-- Optional skills input (Resume + Skills mode) with AI suggestions -->
            <section>
              <div class="topDiv" @click.stop="">
                <FormTags
                  id="skills"
                  label="Skills (optional)"
                  :mandatory="false"
                  placeholder="Enter skills separated by commas"
                  :vmodel="skills"
                  @select-value="skills = $event"
                />
              </div>
              <div class="reassign-main-container-subhead mt-1">
                Skills will be used along with the resume to generate
                verification questions. Leave empty for resume-only questions.
              </div>
            </section>

            <section
              class="
                reassign-main-container-head
                w-100
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div>Candidate Details</div>
              <div>Total Candidate(s): {{ selectedCandidates.length }}</div>
            </section>

            <section class="mt-3">
              <div
                class="common-white-card my-2"
                v-for="(cand, index) in selectedCandidates"
                :key="index"
              >
                <b-card>
                  <section
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      w-100
                    "
                  >
                    <section class="reassign-head-subead w-60 text-truncate">
                      <span
                        style="min-width: auto; max-width: 90%"
                        class="d-inline-block text-truncate"
                        v-b-tooltip.hover.bottom="cand.name"
                      >
                        {{ formattedUsername(cand.name) }}
                      </span>
                    </section>
                    <section
                      class="reassign-head-mail w-40 text-truncate text-right"
                    >
                      <span
                        v-b-tooltip.hover.bottom="cand.email"
                        style="min-width: auto; max-width: 90%"
                        class="d-inline-block text-truncate"
                      >
                        {{ cand.email }}
                      </span>
                    </section>
                    <!-- Drop a candidate from this trigger (keeps at least one). -->
                    <img
                      v-if="selectedCandidates.length > 1"
                      src="../../assets/img/grayclose.svg"
                      class="pointer ml-3 tp-cvs-remove"
                      alt="Remove"
                      v-b-tooltip.hover.left="'Remove'"
                      @click="$emit('remove-candidate', cand.candidateID)"
                    />
                  </section>
                </b-card>
              </div>
            </section>
          </section>
        </section>

        <!-- Result view: newly added / already triggered -->
        <section v-else class="py-3 px-4">
          <section
            class="reassign-main-container p-3"
            :style="'height: calc(100vh - 305px) !important;'"
          >
            <section
              class="
                reassign-main-container-head
                w-100
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <div>Candidate Details</div>
              <div>Total Candidate(s): {{ totalCandidates }}</div>
            </section>
            <section class="mt-3">
              <div class="accordion common-accordian-card" role="tablist">
                <!-- Already triggered / pending -->
                <section
                  class="common-red-accordian-card"
                  v-if="successDetails.alreadyExisting.length"
                >
                  <b-card no-body class="mb-1 px-2 py-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <section
                        @click="toggleAccordion('exists')"
                        v-b-toggle.accordion-tpcvs-1
                        class="
                          w-100
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <section>
                          <div class="reassign-main-container-head">
                            Already Triggered / Pending
                          </div>
                          <div class="reassign-main-container-subhead">
                            Verification invite already pending for Talent Pool
                          </div>
                        </section>
                        <section class="d-flex align-items-center">
                          <div class="reassign-main-container-circle">
                            {{ successDetails.alreadyExisting.length }}
                          </div>
                          <div class="mx-2">
                            <img src="../../assets/img/line.svg" alt="" />
                          </div>
                          <div>
                            <img
                              v-if="isExists"
                              src="../../assets/img/new-reassign-downArrow.svg"
                              class="pointer"
                              alt=""
                            />
                            <img
                              v-else
                              class="pointer"
                              src="../../assets/img/new-reassign-upArrow.svg"
                              alt=""
                            />
                          </div>
                        </section>
                      </section>
                    </b-card-header>
                    <b-collapse
                      id="accordion-tpcvs-1"
                      visible
                      accordion="my-tpcvs-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="p-0 pr-1">
                        <div
                          class="common-white-card my-2"
                          v-for="(
                            cand, index
                          ) in successDetails.alreadyExisting"
                          :key="index"
                        >
                          <b-card>
                            <section
                              class="
                                d-flex
                                align-items-center
                                justify-content-between
                                w-100
                              "
                            >
                              <section
                                class="reassign-head-subead text-truncate w-60"
                              >
                                <span
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                  v-b-tooltip.hover.bottom="cand.name"
                                >
                                  {{ formattedUsername(cand.name) }}
                                </span>
                              </section>
                              <section
                                class="
                                  reassign-head-mail
                                  w-40
                                  text-truncate text-right
                                "
                              >
                                <span
                                  v-b-tooltip.hover.bottom="cand.email"
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                >
                                  {{ cand.email }}
                                </span>
                              </section>
                            </section>
                          </b-card>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </section>

                <!-- Newly triggered -->
                <section
                  class="common-green-accordian-card mt-3"
                  v-if="successDetails.newlyAdded.length"
                >
                  <b-card no-body class="mb-1 px-2 py-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <section
                        @click="toggleAccordion('newlyAdded')"
                        v-b-toggle.accordion-tpcvs-2
                        class="
                          w-100
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <section>
                          <div class="reassign-main-container-head">
                            Newly Triggered
                          </div>
                          <div class="reassign-main-container-subhead">
                            Verification invite sent for Talent Pool
                          </div>
                        </section>
                        <section class="d-flex align-items-center">
                          <div class="reassign-main-container-circle">
                            {{ successDetails.newlyAdded.length }}
                          </div>
                          <div class="mx-2">
                            <img src="../../assets/img/line.svg" alt="" />
                          </div>
                          <div>
                            <img
                              v-if="isNew"
                              src="../../assets/img/accessconnew/blueDownArrow.svg"
                              alt=""
                              class="pointer"
                            />
                            <img
                              v-else
                              class="pointer"
                              src="../../assets/talentpool/blueuparrow.svg"
                              alt=""
                            />
                          </div>
                        </section>
                      </section>
                    </b-card-header>
                    <b-collapse
                      id="accordion-tpcvs-2"
                      visible
                      accordion="my-tpcvs-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="p-0 pr-1">
                        <div
                          class="common-white-card my-2"
                          v-for="(cand, index) in successDetails.newlyAdded"
                          :key="index"
                        >
                          <b-card>
                            <section
                              class="
                                d-flex
                                align-items-center
                                justify-content-between
                                w-100
                              "
                            >
                              <section
                                class="reassign-head-subead text-truncate w-60"
                              >
                                <span
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                  v-b-tooltip.hover.bottom="cand.name"
                                >
                                  {{ formattedUsername(cand.name) }}
                                </span>
                              </section>
                              <section
                                class="
                                  reassign-head-mail
                                  w-40
                                  text-truncate text-right
                                "
                              >
                                <span
                                  v-b-tooltip.hover.bottom="cand.email"
                                  style="min-width: auto; max-width: 90%"
                                  class="d-inline-block text-truncate"
                                >
                                  {{ cand.email }}
                                </span>
                              </section>
                            </section>
                          </b-card>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </section>
              </div>
            </section>
          </section>
        </section>
      </body>

      <hr class="m-0" />
      <footer class="p-3">
        <section
          class="w-100 d-flex justify-content-end align-items-center bluebtn"
        >
          <!-- Confirmation footer -->
          <template v-if="!successDetails">
            <b-button
              v-if="roles.includes('TRIGGER_CVS')"
              class="acs-cancelBtn-modal w-105px mr-3"
              @click="handleClose"
            >
              Cancel
            </b-button>
            <b-button
              class="acs-addBtn-modal w-105px d-flex align-items-center"
              :disabled="submitting"
              @click="emitTrigger"
            >
              <b-spinner v-if="submitting" small class="mr-1"></b-spinner>
              <span>{{ submitting ? "Triggering..." : "Trigger CVS" }}</span>
            </b-button>
          </template>
          <!-- Result footer -->
          <b-button
            v-else
            class="acs-addBtn-modal pl-4 pr-4"
            @click="handleClose"
          >
            Okay
          </b-button>
        </section>
      </footer>
    </main>
  </b-modal>
</template>

<script>
import FormTags from "../../components/InputComponents/FormTags.vue";

export default {
  name: "TriggerCVSModal",
  components: {
    FormTags,
  },
  props: {
    showModal: Boolean,
    roles: {
      type: Array,
      default: () => [],
    },
    // List of selected candidates { name, email } shown on the confirm step
    selectedCandidates: {
      type: Array,
      default: () => [],
    },
    // null while confirming; set with { newlyAdded, alreadyExisting } after trigger
    successDetails: {
      type: Object,
      default: null,
    },
    submitting: Boolean,
  },
  data() {
    return {
      skills: [],
      isExists: false,
      isNew: false,
    };
  },
  computed: {
    totalCandidates() {
      if (!this.successDetails) return 0;
      return (
        (this.successDetails.alreadyExisting?.length || 0) +
        (this.successDetails.newlyAdded?.length || 0)
      );
    },
  },
  methods: {
    formattedUsername(username) {
      return typeof username === "string"
        ? username.replace(/\b\w/g, (char) => char.toUpperCase())
        : username;
    },
    toggleAccordion(val) {
      if (val == "exists") {
        this.isExists = !this.isExists;
      } else if (val == "newlyAdded") {
        this.isNew = !this.isNew;
      }
    },
    emitTrigger() {
      if (this.submitting) return;
      this.$emit("trigger-cvs", [...this.skills]);
    },
    handleClose() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.reassign-head-subead {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.reassign-head-mail {
  font-family: "Lato";
  font-weight: 400;
  font-size: 12px;
  color: #666666;
}

.reassign-main-container {
  background: #f6f9fb;
  border-radius: 6px;
  height: calc(100vh - 450px);
  overflow: auto;
}

.reassign-main-container-head {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
}

.reassign-main-container-subhead {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 11px;
  color: #666666;
}

.reassign-main-container-circle {
  width: 20px;
  height: 20px;
  border: 1px solid #8c8c8c;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #8c8c8c;
  border-radius: 50%;
  text-align: center;
}

.topDiv .customised-form-tags {
  border-radius: 4px;
}

/* accordian classes */
.common-accordian-card .card-header {
  background: transparent;
  border-bottom: unset;
}

.common-accordian-card .common-red-accordian-card > .card {
  border: 2px solid #e70016;
  background: #f6f9fb;
}

.common-accordian-card .common-green-accordian-card > .card {
  border: 2px solid #038e00;
  background: #f6f9fb;
}
</style>

<!--
  Non-scoped styles are required here because the elements we must adjust
  (.customised-form-tags, .text-muted, .invalid-feedback) are rendered inside
  the <FormTags> child component, and Vue <style scoped> does NOT pierce into
  child-component internals.
  To keep these rules fully LOCAL (no effect anywhere else that uses the
  suggest-skills endpoint), every selector is prefixed with this modal's unique
  id (#trigger-cvs-talentpool), which bootstrap-vue applies to the modal root.
-->
<style>
/* Match the workbench Trigger CVS modal (#reAssign-job), which zeroes the
   default bootstrap .modal-body padding; our content supplies its own
   py-3 px-4 spacing, so keep the body flush like the older modal. */
#trigger-cvs-talentpool .modal-body {
  padding: 0;
}

#trigger-cvs-talentpool .topDiv .select-div {
  position: relative;
}

#trigger-cvs-talentpool .topDiv .customised-form-tags {
  position: relative;
}

/* Bring the b-form-tags feedback ("Duplicate tag: pyt") back into normal flow
   so it occupies real layout space above the helper subtitle. Without this,
   global rules (.customised-form-tags .text-muted / .invalid-feedback) force
   it to position:absolute; bottom:-21px, so it paints over the helper text.

   The feedback node is a direct child of the b-form-tags .form-control box,
   which the global stylesheet pins to a fixed 36px height. A fixed-height box
   cannot grow to fit the in-flow message, so we MUST release that height too
   (height: auto, keep the initial visual via min-height) for the message to
   push the helper text down. When the message clears, the box collapses back
   and the helper text returns to its original position. */
#trigger-cvs-talentpool .customised-form-tags .form-control {
  height: auto !important;
  min-height: 36px;
  /* Vertically centre the input/placeholder within the box. Column layout keeps
     the b-form-tags list and its (in-flow) duplicate-tag feedback stacked, and
     justify-content only adds a gap while the content is shorter than the 36px
     min-height (i.e. when empty) — once the feedback grows the box, height ==
     content so the feedback still sits directly below and pushes the helper. */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#trigger-cvs-talentpool .customised-form-tags .text-muted,
#trigger-cvs-talentpool .customised-form-tags .invalid-feedback {
  position: static !important;
  margin-top: 2px;
  bottom: auto !important;
  width: auto !important;
}
</style>
